import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";

const ServiceArea = [
  { label: "Yeşilköy Koltuk Yıkama", path: "/bakirkoy/yesilkoy-koltuk-yikama" },
  { label: "Yeşilköy Perde Yıkama", path: "/bakirkoy/yesilkoy-perde-yikama" },
  { label: "Ataköy Koltuk Yıkama", path: "/bakirkoy/atakoy-koltuk-yikama" },
  { label: "Ataköy Yorgan Yıkama", path: "/bakirkoy/atakoy-yorgan-yikama" },
  { label: "Zeytinlik Koltuk Yıkama", path: "/bakirkoy/zeytinlik-koltuk-yikama" },
  { label: "Zeytinlik Battaniye Yıkama", path: "/bakirkoy/zeytinlik-battaniye-yikama" },
  { label: "Cevizlik Koltuk Yıkama", path: "/bakirkoy/cevizlik-koltuk-yikama" },
  { label: "Cevizlik Kuru Temizleme", path: "/bakirkoy/cevizlik-kuru-temizleme" },
  { label: "Kartaltepe Koltuk Yıkama", path: "/bakirkoy/kartaltepe-koltuk-yikama" },
  { label: "Kartaltepe Yerinde Yıkama", path: "/bakirkoy/kartaltepe-yerinde-yikama" },
  { label: "Bakırköy Merkez Koltuk Yıkama", path: "/bakirkoy/merkez-koltuk-yikama" },
];

const BakirkoyServiceArea = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="text-[#003132] mt-0 w-full">
      <div
        onClick={toggleDropdown}
        className="cursor-pointer flex items-center justify-between bg-[#e2e8f0] p-3 rounded-lg shadow-md hover:bg-[#d1d5db]"
      >
        <h2 className="text-lg font-semibold uppercase tracking-wide">
          BAKIRKÖY HİZMET TÜRLERİ
        </h2>
        {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </div>

      {isOpen && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-3 bg-[#f1f5f9] p-5 rounded-xl shadow-sm border border-gray-200 w-full mt-2">
          {ServiceArea.map((area, index) => (
            <Link
              key={index}
              to={area.path}
              className={`text-sm font-semibold px-4 py-3 rounded-lg text-center transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-green-700 text-white"
                  : "bg-white text-green-900 hover:bg-green-100 hover:text-green-800"
              }`}
            >
              {area.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default BakirkoyServiceArea;
